var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('t-body',[_c('t-sidebar-menu',{attrs:{"title":_vm.$t('fields.organization'),"items":_vm.items}}),_vm._v(" "),_c('nuxt-child')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }